import { render, staticRenderFns } from "./itj.vue?vue&type=template&id=3e3bff78"
import script from "./itj.vue?vue&type=script&lang=js"
export * from "./itj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TfImg: require('/usr/src/app/components/tf/img.vue').default,ButtonOutlineLight: require('/usr/src/app/components/button/outline-light.vue').default})
